<template>
  <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
    <router-link :to="{ name: 'Landing' }" class="mb-12 mb-12 text-center">
      <img alt="Logo" src="@/assets/media/pyb-logo.png" class="h-90px" />
    </router-link>
    <!--begin::Wrapper-->
    <div class="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
      <!--begin::Form-->
      <form
        class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
        novalidate="novalidate"
        id="kt_sign_in_form"
        @submit.prevent="confirm"
      >
        <!--begin::Heading-->
        <div class="text-center mb-10">
          <!--begin::Title-->
          <h1 class="text-dark mb-3">Confirm Your Account!</h1>
          <!--end::Title-->
          <!--begin::Link-->
          <div class="text-gray-400 fw-bold fs-4">
            New Here?
            <a
              @click="createAnAccountButton"
              class="link-primary fw-bolder text-pink"
              >Create an Account</a
            >
          </div>
          <!--end::Link-->
        </div>
        <!--begin::Heading-->
        <!--begin::Input group-->
        <div class="fv-row mb-10 fv-plugins-icon-container">
          <!--begin::Label-->
          <label class="form-label fs-6 fw-bolder text-dark"
            >Email: {{ this.email }}</label
          >
          <!--end::Label-->
          <!--begin::Input-->
          <!--end::Input-->
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
        <div
          class="mb-10 fv-row fv-plugins-icon-container"
          data-kt-password-meter="true"
        >
          <!--begin::Wrapper-->
          <div class="mb-1">
            <!--begin::Label-->
            <label class="form-label fw-bolder text-dark fs-6"
              >New Password</label
            >
            <!--end::Label-->
            <!--begin::Input wrapper-->
            <div class="position-relative mb-3">
              <input
                class="form-control form-control-lg form-control-solid"
                :type="passwordFieldType"
                placeholder=""
                v-model.trim="password"
                autocomplete="off"
                required
                @input="checkPasswordCriteria"
              />
              <span
                class="
                  btn btn-sm btn-icon
                  position-absolute
                  translate-middle
                  top-50
                  end-0
                  me-n2
                "
                data-kt-password-meter-control="visibility"
              >
                <i
                  :class="eyeIconClass"
                  @click="showPassword = !showPassword"
                  :title="eyeIconTitle"
                ></i>
              </span>
            </div>
            <!--end::Input wrapper-->
          </div>
          <!--end::Wrapper-->
          <!--begin::Hint-->
          <div class="text-muted" :style="passInstructionStyle">
            Use 8 or more characters with a mix of
            letters(uppercase&amp;lowercase), numbers &amp; symbols.
          </div>
          <!--end::Hint-->
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
        <!--end::Input group-->
        <!--begin::Input group-->
        <div class="fv-row mb-5 fv-plugins-icon-container">
          <label class="form-label fw-bolder text-dark fs-6"
            >Confirm Password</label
          >
          <input
            class="form-control form-control-lg form-control-solid"
            :type="passwordFieldType"
            placeholder=""
            v-model.trim="confirmPassword"
            name="confirm-password"
            autocomplete="off"
            required
            @blur="checkMatch"
          />
          <div class="fv-plugins-message-container invalid-feedback"></div>
          <span style="color: red" v-if="showUnmatchWarning"
            >Password does not match</span
          >
        </div>
        <!--end::Input group-->
        <!--begin::Actions-->
        <div class="text-center">
          <!--begin::Submit button-->
          <button
            type="submit"
            id="kt_sign_in_submit"
            :class="confirmBtnClass"
            :disabled="!canConfirmAccount"
          >
            <span class="indicator-label">Confirm Account</span>
            <span class="indicator-progress"
              >Please wait...
              <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              ></span
            ></span>
          </button>
          <!--end::Submit button-->
          <!--begin::Separator-->
        </div>
        <!--end::Actions-->
        <div></div>
      </form>
      <!--end::Form-->
    </div>
    <!--end::Wrapper-->
  </div>
</template>

<script>
import { AuthActionTypes } from "@/store/auth/actions";
import Vue from "vue";

export default Vue.extend({
  name: "ConfirmAccountForm",
  props: {
    value: {
      email: {
        type: String,
        required: true,
        default: "",
      },
      code: {
        type: String,
        required: false,
        default: "",
      },
    },
  },
  data() {
    return {
      email: "",
      code: "",
      password: "",
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      showUnmatchWarning: false,
      passInstructionStyle: "",
    };
  },
  computed: {
    confirmBtnClass() {
      const defaultClass = "btn btn-lg w-100 mb-5";
      return this.canConfirmAccount
        ? `${defaultClass} btn-primary`
        : `${defaultClass} btn-secondary disabled`;
    },
    eyeIconTitle() {
      return this.showPassword ? "hide password" : "show password";
    },
    passwordFieldType() {
      return this.showPassword ? "text" : "password";
    },
    eyeIconClass() {
      const defaultClass = "bi fs-2";
      return this.showPassword
        ? `${defaultClass} bi-eye`
        : `${defaultClass} bi-eye-slash`;
    },
    passwordCriteria() {
      return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\`\~\!\@\#\$\%\^\&\*\(\)\_\\\+\=\{\}\[\]\;\:\'\"\,\<\.\>\/\?\-])(?=.{8,})/.test(
        this.password
      );
    },
    passwordMatch() {
      return this.password === this.confirmPassword;
    },
    canConfirmAccount() {
      return this.passwordCriteria && this.passwordMatch;
    },
  },
  methods: {
    checkPasswordCriteria() {
      this.passInstructionStyle = this.passwordCriteria
        ? ""
        : "color:red !important";
    },
    checkMatch() {
      this.showUnmatchWarning = !this.passwordMatch;
    },
    async confirm() {
      const confirm = {
        email: this.email,
        password: this.password,
      };
      this.$emit("confirmAccount", confirm);
    },
    createAnAccountButton() {
      this.$emit("createAnAccountButton");
    },
  },
  async beforeMount() {
    this.email = this.value.email;
    this.code = this.value.code;

    if (this.code) {
      await this.$store.dispatch(AuthActionTypes.Login, {
        email: this.email.value,
        password: this.code,
      });
    }
  },
});
</script>

<style scoped></style>
